import { useEffect, useLayoutEffect } from 'react';

/**
 * `React.useLayoutEffect` that fallbacks to `React.useEffect` on server side
 * rendering.
 */

var useIsomorphicEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;

export { useIsomorphicEffect };
